import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Row, Upload, Select, Switch } from 'antd'
import { selectRule } from '../../../../utils/rules'
import { FormItem } from '../../../../styles/shared.style'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { ROLE } from '../../../../utils/constants'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'
import axios from 'axios'

const UserForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [imageUrl, setImageUrl] = useState('')
  const [file, setFile] = useState(null)
  const [checked, setChecked] = useState(true);


  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        email: formData.email,
        role: formData.role,
        avatar:formData.avatar
      })
      setImageUrl(formData.avatar)
      changeStatus(formData.status)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
      setFile(null)
    }
  }, [formData])

  const changeStatus = (value) => {
   if(value === 'ENABLED' ){
    setChecked(true)
   }
   if(value === 'DISABLED' ){
    setChecked(false)
   }
  };

  const onChange = (check) => {
    setChecked(check)
  };

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          role: values.role,
          avatar:values.avatar
        }
        if(values.email){
          data.email = values.email
        }
        if(values.password){
          data.password = values.password
        }
        if (values.status === false) {
          data.status = 'DISABLED'
        } else {
          data.status = 'ENABLED'
        }
        if (values.avatar) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.avatar.file)) {
              formImgData.append('image', await compressFile(values.avatar.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/userAdmin/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.avatar = res.data.url
            }
          } catch (err) {
            console.log(err)
          }
        }else{
          data.avatar = formData.avatar
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a new user`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <FormItem>
          {getFieldDecorator(`avatar`, {
          })(
            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={(file) => beforeUpload(file)}
              onChange={handleChange}>
              {imageUrl ? (
                <img src={imageUrl} alt="img" style={{ width: '100%' }} />
              ) : (
                uploadButton
              )}
            </Upload>
          )}
        </FormItem>
        <Form.Item label="User Name">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="User Name" />)}
        </Form.Item>
        <Form.Item label="Email">
          {getFieldDecorator(`email`, {
            rules: [
              {
                required: !_.isEmpty(formData) ? false : true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="email"
            placeholder="Email" 
            disabled={`${!_.isEmpty(formData) ? 'disabled' : ''}`}    
            />)}
        </Form.Item>
        <Form.Item label="Password">
          {getFieldDecorator(`password`, {
            rules: [
              {
                required: !_.isEmpty(formData) ? false : true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            type="password"
            name="password"
            placeholder="Password"
            disabled={`${!_.isEmpty(formData) ? 'disabled' : ''}`}    
            />)}
        </Form.Item>
        <Form.Item label="Role">
          {getFieldDecorator(`role`, { ...selectRule })(
            <Select>
              {ROLE.map((role) => {
                return (
                  <Select.Option key={role}>{role}</Select.Option>
                )
              })}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Status">
          {getFieldDecorator(`status`)(
            <Switch
              checkedChildren="ENABLED"
              unCheckedChildren="DISABLED"
              checked={checked} 
              onChange={onChange}
            />
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              {!_.isEmpty(formData) ? 'Save' : 'Create'}
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedUserForm = Form.create({ name: 'UserForm' })(
  UserForm
)
export default WrappedUserForm



// WEBPACK FOOTER //
// ./src/pages/Users/components/UserForm/index.js